export default __webpack_public_path__ + "static/media/features-split-image-01.76b99412.png";